const SoundID = {
    COUNTDOWN: "countdown",
    LANESWITCH: "laneswitch"
};

export default SoundID;